export default "__VITE_ASSET__DFQ9jHTC__"